import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import React from 'react';
import { useTranslation } from 'react-i18next';
import FormField from 'components/FormField';
import { getTypedSelectComponents } from 'components/Select';
import { generalTypes } from 'utils/asset/commonCustomTypes';
import { getContentItemIconFromType } from 'utils/icons';
import { getContentItemTypeTranslationKey } from 'utils/asset/getContentItemType';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var _getTypedSelectCompon = getTypedSelectComponents(),
  Select = _getTypedSelectCompon.Select,
  Option = _getTypedSelectCompon.Option;
var AssetTypeField = function AssetTypeField(_ref) {
  var originalType = _ref.originalType,
    type = _ref.type,
    onChange = _ref.onChange,
    isDisabled = _ref.isDisabled;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var id = 'selectAssetType';
  var originalTypeTitle = "".concat(t(getContentItemTypeTranslationKey(originalType)), " (").concat(t('file_type_default'), ")");

  // If the asset's original type is also a custom type, remove duplicate item from the list
  var customTypeList = generalTypes.filter(function (item) {
    return item.value !== originalType;
  });
  return /*#__PURE__*/_jsx(FormField, {
    label: t('form_displayed_type'),
    labelId: id,
    horizontal: true,
    children: /*#__PURE__*/_jsxs(Select, {
      icon: getContentItemIconFromType(type),
      labelledById: id,
      size: "medium",
      menuPlacement: "top",
      value: type || originalType,
      onChange: onChange,
      variant: "transparent",
      ml: "-xxs",
      isDisabled: isDisabled,
      children: [/*#__PURE__*/_jsx(Option, {
        value: originalType,
        icon: getContentItemIconFromType(originalType),
        children: originalTypeTitle
      }, originalType), customTypeList.map(function (type) {
        return /*#__PURE__*/_jsx(Option, {
          value: type.value,
          icon: type.icon,
          children: t(getContentItemTypeTranslationKey(type.value))
        }, type.value);
      })]
    })
  });
};
export default AssetTypeField;